module.exports = __webpack_public_path__ + "img/xl_nm.8dc1b010.png";